import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { usePushSubscription } from '../../../../redux/pwa/hooks';
import { PushSubscriptionState } from '../../../../redux/pwa/types';
import { isStandaloneApp } from '../../../../utils/isStandaloneApp';
import SuffixText from '../_partials/SuffixText';
export function usePushSubscriptionItem() {
    const pwa = useFlag('pwa');
    const { state, register } = usePushSubscription();
    const { t } = useTranslation();
    const isSubscribed = state === PushSubscriptionState.SUBSCRIBED;
    // Only show the PWA menu item on standalone devices
    if (!isStandaloneApp()) {
        return false;
    }
    return pwa && {
        label: t('siteHeader.userMenu.pwa.loggedIn.label'),
        suffix: /*#__PURE__*/ React.createElement(SuffixText, null, isSubscribed ? t('siteHeader.userMenu.pwa.loggedIn.suffix.enabled') : t('siteHeader.userMenu.pwa.loggedIn.suffix.disabled')),
        onClick: register
    };
}

//# sourceMappingURL=usePushSubscriptionItem.js.map